/* GESKE Wholesale — mobile auto-cycling carousel for the feature grid.
   Activates only at <=768px. Auto-advances (ping-pong) with dot indicators,
   pauses on user interaction / hover / hidden tab, and respects
   prefers-reduced-motion (swipe + dots stay, autoplay is suppressed). */
(function () {
  var mqMobile = window.matchMedia('(max-width: 768px)');
  var mqReduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  function initCarousel(section) {
    var track = section.querySelector('.gkw-features__grid');
    if (!track) return;
    var slides = Array.prototype.slice.call(track.querySelectorAll('.gkw-feature'));
    var dots = Array.prototype.slice.call(section.querySelectorAll('.gkw-features__dot'));
    if (slides.length < 2) return;

    var interval = parseInt(section.getAttribute('data-gkw-autoplay'), 10);
    var autoplay = section.hasAttribute('data-gkw-autoplay') && !isNaN(interval);
    if (!interval || interval < 1500) interval = 4500;

    var idx = 0;
    var dir = 1;
    var timer = null;
    var pauseUntil = 0;

    function updateDots() {
      for (var i = 0; i < dots.length; i++) {
        var on = i === idx;
        dots[i].classList.toggle('is-active', on);
        dots[i].setAttribute('aria-current', on ? 'true' : 'false');
      }
    }

    function syncFromScroll() {
      var centre = track.scrollLeft + track.clientWidth / 2;
      var best = 0;
      var bestDist = Infinity;
      for (var i = 0; i < slides.length; i++) {
        var c = slides[i].offsetLeft - slides[0].offsetLeft + slides[i].offsetWidth / 2;
        var d = Math.abs(c - (track.scrollLeft + track.clientWidth / 2));
        if (d < bestDist) { bestDist = d; best = i; }
      }
      idx = best;
      updateDots();
    }

    function go(i) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      var left = slides[i].offsetLeft - slides[0].offsetLeft;
      track.scrollTo({ left: left, behavior: mqReduce.matches ? 'auto' : 'smooth' });
    }

    function tick() {
      if (!autoplay || mqReduce.matches) return;
      if (document.hidden) return;
      if (Date.now() < pauseUntil) return;
      var next = idx + dir;
      if (next > slides.length - 1) { dir = -1; next = idx + dir; }
      if (next < 0) { dir = 1; next = idx + dir; }
      go(next);
    }

    function start() {
      stop();
      if (!autoplay || mqReduce.matches) return;
      timer = window.setInterval(tick, interval);
    }
    function stop() { if (timer) { window.clearInterval(timer); timer = null; } }
    function pause(ms) { pauseUntil = Date.now() + (ms || 7000); }

    var rafPending = false;
    track.addEventListener('scroll', function () {
      if (rafPending) return;
      rafPending = true;
      window.requestAnimationFrame(function () { rafPending = false; syncFromScroll(); });
    }, { passive: true });

    track.addEventListener('pointerdown', function () { pause(9000); }, { passive: true });
    section.addEventListener('mouseenter', function () { pause(60000); });
    section.addEventListener('mouseleave', function () { pause(2000); });

    for (var i = 0; i < dots.length; i++) {
      (function (n) {
        dots[n].addEventListener('click', function () { go(n); pause(9000); });
      })(i);
    }

    function apply() {
      if (mqMobile.matches) { idx = 0; updateDots(); start(); }
      else { stop(); track.scrollLeft = 0; }
    }

    if (mqMobile.addEventListener) mqMobile.addEventListener('change', apply);
    else if (mqMobile.addListener) mqMobile.addListener(apply);
    if (mqReduce.addEventListener) mqReduce.addEventListener('change', start);

    updateDots();
    apply();
  }

  function init() {
    var sections = document.querySelectorAll('.gkw-features[data-gkw-carousel]');
    for (var i = 0; i < sections.length; i++) {
      if (sections[i].hasAttribute('data-gkw-init')) continue;
      sections[i].setAttribute('data-gkw-init', '');
      initCarousel(sections[i]);
    }
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
